import axios from 'axios';
import { getQuoteRequestBody } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { setKmfApiDetails, setQuoteServiceResponse } from '../../../actions/kaMetlhaFuneralCover/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { navigateNext, navigateToThankYou } from '../../../actions/kaMetlhaFuneralCover/routing';
import httpStatusCode from '../../../../api-server/constants/httpStatusCode';

export const quoteService = (store, next, action) => {
    const state=store.getState();
    (async () => {
        try{
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.PENDING,name:'quoteService'}));
            const sampleRequestBody= getQuoteRequestBody(state)
            const response = await sendQuoteDetails(sampleRequestBody);
        if (response && response.status === httpStatusCode.OK) {
            store.dispatch(setQuoteServiceResponse(response?.data))
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.SUCCESS,name:'quoteService',}));
        } else {
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'quoteService',content:'Unable to fetch the quote. Please try again later.'}));
        }
    }
        catch(error){
            console.log('API ERROR',error);
            store.dispatch(setKmfApiDetails({status:API_CALL_STATUS.FAILURE,name:'quoteService',content:'Unable to fetch the quote. Please try again later.'}));
        }
    })();
    return next(action);
};

const sendQuoteDetails = async (requestBody)=>{
        try {
            const response = await axios({
                url: '/om-api/ka-metlha-funeral/getQuoteDetails',
                // '/om-api/ka-metlha-funeral/getQuoteDetails',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                data: requestBody,
            });
            return response;
        } catch (error) {
            return null;
        }
}
